import { Dispatch } from 'react';
import { getSlugByUrl } from 'tools/tools';
import { GridState } from 'components/common/grid';

const prepareSearchFieldObject = (searchFieldSettings: any) => {
    const defaultName = 'pattern';

    //Default search field
    if (searchFieldSettings === true) {
        return {
            name: defaultName,
        };
    }

    //Search field with settings with default name
    if ('object' == typeof searchFieldSettings && !searchFieldSettings?.name) {
        return { ...searchFieldSettings, name: defaultName };
    }

    //Full custom field settings
    return searchFieldSettings;
};

export const applyGridSettings = (
    settingsUrl: string,
    settings: any,
    dispatch: Dispatch<Partial<GridState>>,
    currentFiltersValue: any,
): void => {
    dispatch({
        settings,
        columns: settings.columns,
        order: settings.order?.order || 'asc',
        orderBy: settings.order?.orderBy || '',
        filtersValue: settings.saveFiltersValues ? (settings.filtersValues ?? {}) : currentFiltersValue,
        resetFiltersButton: settings.resetFilters === 'Y',
        searchField: prepareSearchFieldObject(settings.searchField),
        legendConfig: settings.legend,
        rowExtraInfoConfig: settings.rowExtraInfo,
        pagerOptions: settings.pagerOptions,
        gridTitle: settings.title ?? '',
        gridEntityType: settings.entityType ?? '',
        titleHidden: settings.titleHidden ?? false,
        gridDescription: settings.gridDescription,
        dragAndDrop: settings.dragAndDrop,
        massActions: settings.massActions ?? { enabled: false },
        buttons: settings.customButtons,
        controllerUrl: settings.controllerUrl,
        gridName: getSlugByUrl(settingsUrl),
        emptyTitle: settings.emptyTitle ?? 'empty_grid_title.no_data_found',
        emptyIcon: settings.emptyIcon,
        hideEmpty: settings.hideEmpty ?? false,
        resetColumns: settings.resetColumns ?? true,
        switchColumns: settings.switchColumns ?? true,
        widthToggle: settings.widthToggle ?? false,
        saveFiltersValues: settings.saveFiltersValues ?? false,
        dependentGrids: settings.dependentGrids ?? [],
        noSearchResult: settings.noSearchResult,
        infoButton: settings.infoButton,
        visibleFilters: settings.visibleFilters,
        multilines: settings.multilines,
        autoRowHeight: settings.autoRowHeight,
        defaultRowHeight: settings.defaultRowHeight ?? 32,
        gridParams: settings.gridParams ?? null,
        changeViewConfig: settings.viewConfig ?? null,
        customLegend: settings.customLegend ?? false,
        filtersList: settings.filters ?? [],
    });
};
